import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sportsData';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://www.kaitiyu.com${item.href}` : undefined,
        name: item.label,
      },
    })),
  };

  const getCategoryName = (slug: string): string => {
    const cat = sportCategories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <nav aria-label="面包屑导航" className="bg-background-100/80 border-b border-background-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <ol className="flex items-center gap-2 py-3 text-sm text-foreground-600 flex-wrap">
            {items.map((item, index) => {
              const isLast = index === items.length - 1;
              const displayLabel = item.label.includes('category/')
                ? getCategoryName(item.label.replace('category/', ''))
                : item.label;
              return (
                <li key={index} className="flex items-center gap-2">
                  {index > 0 && (
                    <span className="text-foreground-400 mx-1">/</span>
                  )}
                  {isLast || !item.href ? (
                    <span className="text-foreground-900 font-medium">{displayLabel}</span>
                  ) : (
                    <Link
                      to={item.href}
                      className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {displayLabel}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </nav>
    </>
  );
}